import * as Types from './popupActionTypes.js'

const initialState = {
    popups: []   
};

export default function user(state = initialState, action) {
    switch (action.type) {
        case Types.SET_POPUPS:
            if (state.popups !== action.popups) {
                return Object.assign({}, state, { popups: action.popups });
            }
            return state;
     
        default:
            return state;
    }
}